import { FC, ReactElement, useEffect } from 'react';

import { UrgentBanner } from '../../containers';
import { fetchUrgentBanner } from '../../redux/@blocks/urgentBanner/urgentBannerActions';
import { useTypedDispatch, useTypedSelector } from '../../redux/store';

export const ConnectedUrgentBanner: FC = (): ReactElement | null => {
    const dispatch = useTypedDispatch();

    const urgentBanner = useTypedSelector(state => state.urgentBannerSlice.urgentBanner);

    useEffect((): void => {
        dispatch(fetchUrgentBanner());
    }, []);

    if (!urgentBanner) {
        return null;
    }

    return (
        <UrgentBanner
            id={urgentBanner.id}
            text={urgentBanner.text}
            links={urgentBanner.links}
            backgroundColor={urgentBanner.backgroundColor}
            textColor={urgentBanner.textColor}
        />
    );
};
